angular.module('virtoCommerce.marketplaceModule')
    .factory('virtoCommerce.marketplaceModule.webApi', ['$resource', function ($resource) {
        return $resource('api/vcmp', null, {
            // settings
            getSettings: { method: 'GET', url: 'api/vcmp/settings' },
            // seller
            sendInvitation: { method: 'POST', url: 'api/vcmp/security/seller/send/invitation' },
            createSeller: { method: 'POST', url: 'api/vcmp/security/seller/create' },
            updateSeller: { method: 'POST', url: 'api/vcmp/security/seller/update' },
            searchSellers: { method: 'POST', url: 'api/vcmp/security/seller/search' },
            deleteSellers: { method: 'DELETE', url: 'api/vcmp/security/seller' },
            getSellerById: { method: 'GET', url: 'api/vcmp/security/seller/:id' },
            // seller users
            sendSellerUserInvitation: { method: 'POST', url: 'api/vcmp/security/seller/users/invitation/send' },
            validateSellerUser: { method: 'POST', url: 'api/vcmp/security/seller/users/validate', isArray: true },
            createSellerUser: { method: 'POST', url: 'api/vcmp/security/seller/users/create' },
            updateSellerUser: { method: 'POST', url: 'api/vcmp/security/seller/users/update' },
            searchSellerUsers: { method: 'POST', url: 'api/vcmp/security/seller/users/search' },
            deleteSellerUsers: { method: 'DELETE', url: 'api/vcmp/security/seller/users' },
            // seller categories
            createSellerCategories: { method: 'POST', url: 'api/vcmp/seller/categories/create' },
            deleteSellerCategories: { method: 'POST', url: 'api/vcmp/seller/categories/delete' },
            // seller products
            getSellerProduct: { method: 'GET', url: 'api/vcmp/seller/products/:productId' },
            listitemssearch: { method: 'POST', url: 'api/vcmp/seller/products/search' },
            changeStatus: { method: 'POST', url: 'api/vcmp/seller/product/status/change' },
            massChangeStatus: { method: 'POST', url: 'api/vcmp/seller/products/status/:status' },
            deleteSellerProducts: { method: 'DELETE', url: 'api/vcmp/seller/products' },
            // seller import profiles
            getImporters: { method: 'GET', url: 'api/vcmp/import/importers', isArray: true },
            searchSellerImportProfiles: { method: 'POST', url: 'api/vcmp/import/profiles/search' },
            createSellerImportProfile: { method: 'POST', url: 'api/vcmp/import/profiles' },
            updateSellerImportProfile: { method: 'PUT', url: 'api/vcmp/import/profiles' },
            deleteSellerImportProfiles: { method: 'DELETE', url: 'api/vcmp/import/profiles' },
            // fees
            createFee: { method: 'POST', url: 'api/vcmp/fees' },
            updateFee: { method: 'PUT', url: 'api/vcmp/fees' },
            searchFees: { method: 'POST', url: 'api/vcmp/fees/search' },
            deleteFee: { method: 'DELETE', url: 'api/vcmp/fees' },
            getFeeById: { method: 'GET', url: 'api/vcmp/fees/:id' },
            getNewFee: { method: 'GET', url: 'api/vcmp/fees/new' },
            // offers
            searchOffers: { method: 'POST', url: 'api/vcmp/seller/offers/search' },
            getOfferById: { method: 'GET', url: 'api/vcmp/seller/offers/:offerId' },
            deleteOffers: { method: 'DELETE', url: 'api/vcmp/seller/offers' },
            changeState: { method: 'POST', url: 'api/vcmp/seller/offers/state' },
            // sync
            getSyncClients: { method: 'GET', url: 'api/vcmp/sync/clients', isArray: true },
            syncRun: { method: 'POST', url: 'api/vcmp/sync/run' },
            syncCancel: { method: 'POST', url: 'api/vcmp/sync/cancel' },
            // import history
            searchImportHistory: { method: 'POST', url: 'api/vcmp/import/profiles/execution/history/search' },
            // state machine
            searchStateMachineDefinition: { method: 'POST', url: 'api/vcmp/statemachine/definitions/search' },
            updateStateMachineDefinition: { method: 'POST', url: 'api/vcmp/statemachine/definitions/new' },
            searchStateMachineInstance: { method: 'POST', url: 'api/vcmp/statemachine/instances/search' },
            getStateMachineInstanceById: { method: 'GET', url: 'api/vcmp/statemachine/instances/:instanceId' },
            createStateMachineInstance: { method: 'POST', url: 'api/vcmp/statemachine/instances/:definitionId/new' },
            fireStateMachineInstanceTrigger: { method: 'POST', url: 'api/vcmp/statemachine/instances/:instanceId/fire/:trigger/:entityId' },
        });
    }]);
